var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-purchase-callback-page" },
    [
      _c(
        "b-container",
        [
          _vm.checking
            ? _c("Loading", {
                attrs: {
                  text:
                    "Deine Zahlung wird geprüft. Bitte warte und schließe das Browserfenster nicht."
                }
              })
            : _vm.status
            ? _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("Icon", {
                    attrs: { icon: _vm.statusIcon, color: _vm.statusColor }
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(_vm.statusTitle))]),
                  _vm._v(" "),
                  _vm.status === _vm.statusList.notFound
                    ? _c("div", [
                        _vm._v(
                          "\n\t\t\t\tEs ist ein Fehler aufgetreten. Bitte wende dich an unseren Support.\n\t\t\t"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === _vm.statusList.aborted
                    ? _c("div", [
                        _vm._v(
                          "\n\t\t\t\tDie Zahlung wurde abgebrochen. Du kannst diese neuerlich starten.\n\t\t\t"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === _vm.statusList.success
                    ? _c("div", [
                        _c("div", [
                          _vm._v(
                            "Die Zahlung war erfolgreich. Vielen Dank für deinen Einkauf."
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-1" }, [
                          _vm._v("Die Rechnung erhältst du per E-Mail.")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === _vm.statusList.pending
                    ? _c("div", [
                        _c("div", [
                          _vm._v(
                            "Wir konnten die Prüfung noch nicht final abschließen."
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-1" }, [
                          _vm._v(
                            "Du erhältst eine E-Mail sobald dies erledigt ist."
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.status === _vm.statusList.error
                    ? _c("div", [
                        _c("div", [
                          _vm._v("Die Zahlung war leider nicht erfolgreich.")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-1" }, [
                          _vm._v(
                            "Versuche es erneut oder wende dich an unseren Support."
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }